


















import Vue from 'vue';
import ApiConfiguration from '@/classes/ApiConfiguration';
import { SingleSignOnUserConfigurationModel } from '@/services/GeneratedApi';
import { ListModel, ListHeaderModel } from '@/types';

export default Vue.extend({
  name: 'SingleSignOnProviderList',
  data() {
    return { isLoading: true, singleSignOnUserConfiguration: {} as SingleSignOnUserConfigurationModel };
  },
  props: {
    value: {
      required: true
    },
    formId: {
      required: false,
      type: String
    },
    id: {
      required: false,
      default: 'authClient',
      type: String
    },
    autoSelectSingleOption: {
      default: false,
      type: Boolean
    }
  },
  methods: {
    async getSingleSignOnProviders(this: any) {
      this.isLoading = true;
      try {
        this.singleSignOnUserConfiguration = await ApiConfiguration.api().users.usersAuthclientsList();
        const enabledAuthClients = this.authClientList.list.filter((authClient: any) => authClient.isEnabled);
        if (this.autoSelectSingleOption && enabledAuthClients.length === 1) {
          this.selectedAuthClientId = enabledAuthClients[0].id;
        }
      } catch (error) {
        this.$log('Failed to get auth clients: ', error);
      } finally {
        this.isLoading = false;
      }
    }
  },
  computed: {
    htmlElementId() {
      return this.formId ? `${this.formId}.${this.id}` : this.id;
    },
    selectedAuthClientId: {
      set(this: any, value) {
        this.$emit('input', value === '' ? null : value);
      },
      get(this: any) {
        return this.value;
      }
    },
    authClientList(this: any): ListModel {
      return this.singleSignOnUserConfiguration.authClients?.length > 0
        ? {
            id: 0,
            key: 'provider',
            text: 'Provider',
            headers: this.LIST_FIELDS as ListHeaderModel[],
            list: this.singleSignOnUserConfiguration.authClients,
            totalRow: this.singleSignOnUserConfiguration.authClients.length,
            resultType: 1,
            listDataResultTypeMessage: ''
          }
        : ({} as ListModel);
    },
    fieldLabel(this: any): string {
      return `Single Sign-on Provider ${this.isLoading || this.singleSignOnUserConfiguration.isSingleSignOnEnabled ? '' : '(disabled)'}`;
    }
  },
  async mounted(this: any) {
    await this.getSingleSignOnProviders();
  },
  components: {
    MStoreFormSelectTable: () => import('@/components/shared/MStoreFormSelectTable.vue')
  },
  created(this: any) {
    this.LIST_FIELDS = [
      {
        id: '',
        data: 'provider',
        title: 'Provider',
        key: 'provider',
        label: 'Provider'
      }
    ];
  }
});
